export default "__VITE_ASSET__2b6f903c__"